import { __assign, __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import { flexCenterStyle, radius, styled } from '../../../../foundation';
import { RcIcon } from '../../../Icon';
import { iconColor, iconTextColor } from '../utils';
export var _StyledCircleIcon = function (_a) {
    var isEdit = _a.isEdit, rest = __rest(_a, ["isEdit"]);
    return React.createElement(RcIcon, __assign({}, rest));
};
export var StyledCircleIcon = styled(_StyledCircleIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 24px;\n  height: 24px;\n  ", ";\n  color: ", ";\n  svg {\n    stroke-width: ", "px;\n  }\n  border-radius: ", ";\n  background: ", ";\n"], ["\n  width: 24px;\n  height: 24px;\n  ", ";\n  color: ", ";\n  svg {\n    stroke-width: ", "px;\n  }\n  border-radius: ", ";\n  background: ", ";\n"])), flexCenterStyle, iconTextColor, function (_a) {
    var isEdit = _a.isEdit;
    return (isEdit ? 1 : 2);
}, radius('circle'), iconColor);
var templateObject_1;
